import $ from 'jquery';

function NaviCtrl(target) {
	this.$target = $(target);
	this.$button = $('.g-navi-btn');
	this.isTouch = false;
}

NaviCtrl.prototype.init = function () {
	var button = this.$button;
	var self = this;
	button.on({
		'touchstart': function () {
			self.isTouch = true;
			$(this).addClass('touch');
		},
		'touchmove': function () {
			self.isTouch = false;
			$(this).removeClass('touch');
		},
		'touchend': function () {
			if (self.isTouch) {
				self.$target.toggleClass('g-active');
				$(this).removeClass('touch');
			}
		},
		'click': function () {
			if (self.isTouch === false) {
				self.$target.toggleClass('g-active');
			}
		}
	})
}

export default NaviCtrl;